import { useLazyQuery } from '@apollo/client'

import { useEffect, useState } from 'react'

import { Box } from '@grupoboticario/flora-react'

import { EVENT_TYPES } from '@/constants/benefitIds'
import { GET_EVENT_SIGNED_URL } from '@/graphql/queries/getEventSignedUrl'

import EventDaysSection from './EventDaysSection'
import * as S from './EventInformation.styles'
import LocationSection from './LocationSection'
import MainInformation from './MainInformation'

const EventInformation = ({ values, setFieldValue, isReadOnly = false }) => {
  const [imagePreview, setImagePreview] = useState(null)
  const [getSignedUrl] = useLazyQuery(GET_EVENT_SIGNED_URL, { fetchPolicy: 'network-only' })

  useEffect(() => {
    if (values.imageUrl && !imagePreview) {
      setImagePreview(values.imageUrl)
    } else if (values.imagePreviewUrl && !imagePreview) {
      setImagePreview(values.imagePreviewUrl)
    }
  }, [values.imageUrl, values.imagePreviewUrl, imagePreview])

  useEffect(() => {
    if (values.type === EVENT_TYPES.FACTORY_VISIT) {
      if (values.eventLimitPerCpf) {
        setFieldValue('eventLimitPerCpf', '')
      }

      if (Array.isArray(values.days)) {
        const needsUpdate = values.days.some((day) => day.limitPerCpf !== '1')
        if (needsUpdate) {
          const updatedDays = values.days.map((day) => ({ ...day, limitPerCpf: '1' }))
          setFieldValue('days', updatedDays)
        }
      }
    }
  }, [values.type, values.days, values.eventLimitPerCpf, setFieldValue])

  useEffect(() => {
    const preventDefaults = (e) => {
      e.preventDefault()
      e.stopPropagation()
    }

    const events = ['dragenter', 'dragover', 'dragleave', 'drop']
    for (const eventName of events) {
      document.body.addEventListener(eventName, preventDefaults)
    }

    return () => {
      for (const eventName of events) {
        document.body.removeEventListener(eventName, preventDefaults)
      }
    }
  }, [])

  return (
    <Box css={S.paddingBottomCss}>
      <Box as="fieldset" css={S.fieldsetCss} disabled={isReadOnly}>
        <MainInformation
          getSignedUrl={getSignedUrl}
          imagePreview={imagePreview}
          isReadOnly={isReadOnly}
          setFieldValue={setFieldValue}
          setImagePreview={setImagePreview}
          values={values}
        />

        <LocationSection setFieldValue={setFieldValue} values={values} />

        <EventDaysSection setFieldValue={setFieldValue} values={values} />
      </Box>
    </Box>
  )
}

export default EventInformation
